const resource = 'categories'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, { params })
  },
  get(id, params) {
    return $axios.$get(`/${resource}/${id}`, { params })
  },
  getAdminStats(categoryId) {
    return $axios.$get(`/${resource}/${categoryId}/admin-stats`)
  },
  fetchMenuDomains() {
    return $axios.$get('/v2/menu/domains')
  },
  fetchMenuDomainSubmenu(domainId) {
    return $axios.$get(`/v2/menu/domains/${domainId}`)
  },
  fetchCategoryPage(slugOrId) {
    return $axios.$get(`/v2/category-page/${slugOrId}`)
  },

  fetchAccountProDiscountDomains() {
    return $axios.$get('/v2/account/pro/discount-domains')
  },

  getServiceName: name => 'categoryService',
})
